import {
  iconCommonProps, iconDefaultProps, iconPropTypes
} from '../propTypes';

const Youtube = ({ className, color }) => (
  <svg
    className={ className }
    { ...iconCommonProps }
    viewBox='0 0 37 25'
  >
    <g clipPath='url(#prefix__clip0_349:490)'>
      <path
        d='M14.76 17.748V7.252l9.674 5.248-9.674 5.248zM36.302 3.912c-.399-1.526-1.696-2.767-3.291-3.149C30.119 0 18.55 0 18.55 0S6.98 0 4.089.763c-1.596.382-2.892 1.623-3.291 3.15C0 6.678 0 12.5 0 12.5s0 5.82.798 8.588c.399 1.526 1.695 2.767 3.29 3.149C6.982 25 18.55 25 18.55 25s11.569 0 14.46-.763c1.596-.382 2.893-1.622 3.292-3.15.798-2.766.798-8.587.798-8.587s-.1-5.82-.798-8.588z'
        fill={ color }
      />
    </g>
    <defs>
      <clipPath id='prefix__clip0_349:490'>
        <path
          d='M0 0h37v25H0z'
          fill={ color }
        />
      </clipPath>
    </defs>
  </svg>
);

Youtube.propTypes = { ...iconPropTypes };

Youtube.defaultProps = { ...iconDefaultProps };

export default Youtube;